import $ from 'jquery';

function initSlider() {
    $('.js-routes-slider').slick({
        dots: false,
        slidesToShow: 4,
        slidesToScroll: 1,
        arrows: true,
        infinite: false,
        responsive: [
        {
            breakpoint: 1800,
            settings: {
                dots: false,
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
           }
        },
        {
            breakpoint: 1024,
            settings: {
                dots: false,
                slidesToShow: 3.1,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
           }
        },
        {
            breakpoint: 768,
            settings: {
                dots: false,
                slidesToShow: 2.1,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
           }
        },
        {
            breakpoint: 520,
            settings: {
                dots: false,
                slidesToShow: 1.1,
                slidesToScroll: 1,
                arrows: false,
                infinite: false,
           }
        }
        ]
    });
}

$(document).ready(function() {
    initSlider();
    
    $(document).on('click', '.js-vi-button', function() {
        if ($('.b-vi-top-control').is(":visible")) {
            $('.js-routes-slider').slick('destroy');
        } else {
            initSlider();
        }
    });
    $(document).on('click', '.b-vi-top-control__version', function() {
        initSlider();
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/one-museum/museum-routes-slider.js